import { TOUR_EMBED_URL, TOUR_WATCH_URL } from "./tour-video";

export function configureProductTour(): void {
  const trigger = document.querySelector<HTMLAnchorElement>("[data-hero-video-play]");
  const dialog = document.querySelector<HTMLDialogElement>("#tour-dialog");
  const player = dialog?.querySelector<HTMLElement>("[data-tour-player]");
  const watchLink = dialog?.querySelector<HTMLAnchorElement>("[data-tour-watch-link]");
  if (!trigger || !dialog || !player) return;

  if (watchLink) watchLink.href = TOUR_WATCH_URL;

  trigger.addEventListener("click", (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof dialog.showModal !== "function") return;
    event.preventDefault();
    if (dialog.open) return;

    dialog.showModal();
    document.documentElement.classList.add("tour-open");

    const frame = document.createElement("iframe");
    frame.title = "Hogly Complete Tour: PostHog on Your iPhone";
    frame.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen";
    frame.allowFullscreen = true;
    frame.referrerPolicy = "strict-origin-when-cross-origin";
    frame.src = `${TOUR_EMBED_URL}?autoplay=1&playsinline=1&rel=0`;
    player.replaceChildren(frame);
  });

  dialog.querySelector("[data-tour-close]")?.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener("close", () => {
    // Removing the browsing context also stops audio and releases the player.
    player.replaceChildren();
    document.documentElement.classList.remove("tour-open");
    trigger.focus({ preventScroll: true });
  });
}
